// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"theme-bg_wrapper__u_p6z"};